import { render, staticRenderFns } from "./ConsiderVoluntaryPayments.vue?vue&type=template&id=60f3bea0&scoped=true"
import script from "./ConsiderVoluntaryPayments.vue?vue&type=script&lang=js"
export * from "./ConsiderVoluntaryPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f3bea0",
  null
  
)

export default component.exports